import './linked_in_content.js.coffee'
Namespace 'Monitoring.Models.SocialContents.LinkedIn'


class Monitoring.Models.SocialContents.LinkedIn.LinkedInCommentContent extends
      Monitoring.Models.SocialContents.LinkedIn.LinkedInContent

  constructor: (linkedInAuthor, linkedInComment) ->
    @linkedInComment = linkedInComment
    super(linkedInAuthor)

  getJson: ->
    new Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInCommentSerializer().serialize(@)

  getMainText: ->
    @linkedInComment.getText()

  getCreatedAt: ->
    @linkedInComment.getCreatedAt()

  getParentId: ->
    @linkedInComment.getParentPostId()

  getParentCommentId: ->
    @linkedInComment.getParentCommentId()

  getContentId: ->
    @linkedInComment.getContentId()

  isBrandContent: ->
    @linkedInComment.getIsBrandContent()

  getSubType: ->
    'li-comment'

  getPrivacy: ->
    'public'
